export const TOAST_SETTING_AUTOCLOSE = true;
export const TOAST_SETTING_HIDE_PROGRESSBAR = false;
export const CUSTOM_TOAST_CLASSNAME = "custom_toast ";
export const CUSTOM_TOAST_SUCCESS_CLASSNAME = CUSTOM_TOAST_CLASSNAME + "custom_toast_success";
export const CUSTOM_TOAST_ERROR_CLASSNAME = CUSTOM_TOAST_CLASSNAME + "custom_toast_error";
export const VPN_CONNECTION_IN_PROGRESS = "connecting"
export const VPN_CONNECTED = "conneted"
export const VPN_DISCONNECTED = "disconnected"